import { defaultFlareProviderConfiguration } from '../default-constants';

export const BLAZE_SWAP_FLARE_CONTRACT_ADDRESS = '0xe3A1b355ca63abCBC9589334B5e609583C7BAa06';

export const BLAZE_SWAP_FLARE_PROVIDER_CONFIGURATION = defaultFlareProviderConfiguration;
